import { IsString, IsNumber, IsBoolean, IsOptional, MinLength, Min, ValidateNested } from 'class-validator';
import { MultilingualTextDto } from '@/common/dto/multilingual-text.dto';
import { Type } from 'class-transformer';
import { ApiProperty } from '@nestjs/swagger';

export class CreateCountryDto {
  @ApiProperty({ type: MultilingualTextDto, description: 'Country name in multiple languages' })
  @ValidateNested()
  @Type(() => MultilingualTextDto)  
  name: MultilingualTextDto;

  @IsString()
  @MinLength(2)
  code: string;

  @IsNumber()
  @Min(0)
  defaultShippingCost: number;

  @IsOptional()
  @IsBoolean()
  isActive?: boolean = true;
}